import { useState } from "react"
import goldup from "../Assets/goldup.png"

const QuestionCard=({question,url,answer,index,openIndex,setOpenIndex})=>
{
    const[open,isOpen]=useState(false)
    
    const handleButtonClick = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index));
      };
    return(
        <div>
            <div onClick={() => handleButtonClick(index)} className=" cursor-pointer flex justify-between items-center px-[40px] py-[16px] bg-[#F2F2F2] mb-[20px] gap-[20px]">
                <p style={{fontFamily:"Inter"}} className="lg:text-[18px] text-[#656565] font-[400] leading-[22px]">{question}</p>
                <img src={index===openIndex?goldup:url}/>
            </div>
            <p style={{ fontFamily: "Inter", display: index===openIndex ? "block" : "none", whiteSpace: "pre-wrap" }} className="lg:text-[18px] text-[#656565] font-[400] lg:leading-[31px] mx-[30px] mt-[10px] mb-[30px]">
        {answer}
      </p>
        </div>
    )
}
export default QuestionCard